module.exports = __webpack_public_path__ + "img/cases-brand-herborist-lazyload-51.01671686.jpg";